import { render, staticRenderFns } from "./GlobalDialogTable.vue?vue&type=template&id=d163cdf4&scoped=true"
import script from "./GlobalDialogTable.vue?vue&type=script&lang=js"
export * from "./GlobalDialogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d163cdf4",
  null
  
)

export default component.exports